const config = {
  url: "https://resource.a.deascuola.it/v1",
};
module.exports = config;
